<style scoped>
.query-form {
    margin-top: 40px;
}
</style>

<template>
    <div>
        <h1>后台用户管理</h1>
        <div class="query-form">
            <el-form ref="queryForm" :model="form" label-width="80px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="用户名称">
                            <el-input v-model="form.accountName" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="用户状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div>
            <el-table :data="consoleUserListData" @cell-click="cellClick" border style="width:100%">
                <el-table-column prop="userId" label="用户ID" width="200"></el-table-column>
                <el-table-column prop="accountName" label="用户名称" width="200"></el-table-column>
                <el-table-column prop="userGroup" label="用户分组" :formatter="userGroupFormatter" width="200"></el-table-column>                
                <el-table-column prop="status" label="用户状态" :formatter="userStatusFormatter" width="200"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">                    
                        <el-button v-if="scope.row.status==1" @click="forbiddenUser(scope.row)" type="text" size="small">禁用</el-button>
                        <el-button v-if="scope.row.status==3" @click="enableConsoleUser(scope.row)" type="text" size="small">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="currentPage" :page-size="pageSize" @current-change="pageCurrentChange"
            background layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <div>
            <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
                <el-form ref="userGroupform" :model="userGroupform" :rules="userGroupRule">
                    <el-form-item label="活动名称" label-width="80px">
                        <el-select size="mini" v-model="userGroupform.userGroup" multiple style="width:300px;">
                            <el-option v-for="item in userGroup"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible=false">取消</el-button>
                    <el-button type="primary" @click="submitUserGroup('userGroupform')">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {getConsoleUserList, forbiddenConsoleUser, enableConsoleUser, updateUserGroup} from '@/request/api';
export default {
    data() {
    var userGroupSelected = (rule, value, callback) => {
        console.log(value);
        if (value.length == 0) {
            return callback(new Error('用户分组不能为空'));
        }
        callback();
    };
      return { 
        userGroupRule: {
            userGroup: [
                { validator: userGroupSelected, trigger: 'blur'}
            ],
        },
        options: [{
            value: 1,
            label: '正常'
        }, {
            value: 3,
            label: '禁用'
        }],
        
        form: {
          accountName: '',
          status: 1
        },
        userGroup: app.userGroup,
        dialogFormVisible: false,
        userGroupform: {
            userId: 0,
            userGroup: 0
        },
        currentPage: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
        consoleUserListData: [{

        }],
      }
    },
    methods: {
      cellClick(row, column, cell, event) {
        if (column.label === '用户分组') {
            this.dialogFormVisible = true;
            this.userGroupform.userId = row.userId;
        }
      },
      submitUserGroup(formName) {
        this.$refs[formName].validate((valid) => {
            if (this.userGroupform.userGroup.length === 0) {
                this.$message.success("用户分组不能为空");
                return;
            }
            if (valid) {
                updateUserGroup({
                    userId: this.userGroupform.userId,
                    userGroupList: this.userGroupform.userGroup,
                }).then(res => {
                    var status = res.status;
                    var msg = res.msg;
                    if (status === '2') {
                        this.$message.error(msg);
                    } else {
                        this.$message.success("修改成功");
                        this.onSubmit();
                        this.$refs['userGroupform'].resetFields();
                    }
                    this.dialogFormVisible=false;
                    
                })


            } else {
                console.log('error');
                return false;
            }
        })
        
      },
      onSubmit() {
        getConsoleUserList({
            accountName: this.form.accountName,
            status: this.form.status,
            page: this.currentPage,
            size: this.pageSize
        }).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.consoleUserListData = data.list;
                this.currentPage = data.pageNum;
                this.pagea = data.pages;
                this.total = data.total;
            }
        })
      },
      pageCurrentChange(val) {
        this.currentPage = val;
        this.onSubmit()
      },
      forbiddenUser(row) {
        var userId = row.userId;
        var accountName = row.accountName;

        this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                forbiddenConsoleUser({
                    userIdList: [userId]
                }).then(res => {
                    var status = res.status;
                    var msg = res.msg;
                    if (status === '2') {
                        this.$message.error(msg);
                    } else {  
                        this.$message({
                            type: 'success',
                            message: '禁用成功!'
                        });
                        this.onSubmit();
                    }
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消操作'
            });          
        });
      },
      enableConsoleUser(row) {
        var userId = row.userId;
        var accountName = row.accountName;

        this.$confirm('此操作将启用该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                enableConsoleUser({
                    userIdList: [userId]
                }).then(res => {
                    var status = res.status;
                    var msg = res.msg;
                    if (status === '2') {
                        this.$message.error(msg);
                    } else {  
                        this.$message({
                            type: 'success',
                            message: '启用成功!'
                        });
                        this.onSubmit();
                    }
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消操作'
            });          
        });
      },
      userGroupFormatter(data) {
          var groupStr = "";

          if (data.userGroup & 1) {
              groupStr += " 用户运营";
          }
          if (data.userGroup & 2) {
              groupStr += " 商业化";
          }
          if (data.userGroup & 4) {
              groupStr += " 活动运营";
          }
          if (data.userGroup & 8) {
              groupStr += " 内容运营";
          }
          if (data.userGroup & 16) {
              groupStr += " 管理员";
          }
          if (data.userGroup & 32) {
              groupStr += " 超级管理员";
          }

          return groupStr;
      },
      userStatusFormatter(data) {
          if (data.status === 1) {
              return '正常';
          }
          if (data.status === 3) {
              return '禁用';
          }
      }
    },
    created(){
        this.onSubmit();
    }
}
</script>



// WEBPACK FOOTER //
// src/page/user/consoleUserInfo.vue